import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import {Accordion, AccordionDetails, AccordionSummary} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import LinkedItemsList from "../../../../../LinkedItemsSection/components/LinkedItemsList";

import styles from "./styles";


const AssetCardLinks = ({classes, currentLinks, objectType, mainItemTypeId}) => {
  const [expanded, setExpanded] = React.useState(true);

  return (
    <Accordion
      expanded={expanded}
      onChange={undefined}
      classes={{root: classes.accordionRoot}}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        IconButtonProps={{
          classes: {edgeEnd: classes.accButtonIconEdgeEnd},
          onClick: () => setExpanded(!expanded)
        }}
        classes={{
          root: classes.accordionSummaryRoot,
          expanded: classes.accordionSummaryExpanded,
          content: classes.accordionSummaryContent,
        }}
        aria-controls="panel1d-content"
        id="panel1d-header"
      >
        <b className={classes.subCategoryName}>Verknüpfungen</b>&nbsp;<span className={classes.linksCounter}>({currentLinks.length})</span>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <LinkedItemsList linkedItems={currentLinks} objectType={objectType} mainItemTypeId={mainItemTypeId} />
      </AccordionDetails>
    </Accordion>
  )
};

export default withStyles(styles)(AssetCardLinks);